export function hasChatsAccess(profile) {
  return Boolean(
    profile?.isCalendarAdmin ||
      profile?.isCompanyOwner ||
      profile?.isPlatformAdmin
  )
}
